<template>
    <v-row justify-center>
        <v-dialog v-model="mostrar" persistent max-width="700px">
            <v-card>
        <v-card-title>
          <span class="headline">Crear Lote YEAH</span>
        </v-card-title>
        <v-card-text>
          <v-container>
              <v-row>
                  <v-col>
                      <v-alert v-if="mensaje_alert"
                        outlined
                        type="info"
                        
                        dense
                        >
                        {{mensaje_alert}}
                    </v-alert>
                  </v-col>
              </v-row>
            <v-row>
                <v-col>
                    <span v-if="mostrar_loader">
                        <v-progress-linear
                            indeterminate
                            color="green"
                        ></v-progress-linear> {{mensaje_loader}}
                    </span>
                </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field label="N° Lote*" v-model="lote"></v-text-field>
              </v-col>
              <v-col>
                  <v-datetime-picker 
                  label="Seleccione Fecha y Hora*"
                  dateFormat="dd-MM-yyyy"
                  :first-day-of-week="1"
                  timeFormat="HH:mm"
                  clearText="Borrar"
                  okText="Aceptar"
                  v-model="datetime"></v-datetime-picker>
              </v-col>
            </v-row>
            <v-row>
                <v-col>
                  <v-autocomplete
                                        v-model="especie"
                                        :items="especies"
                                        item-text="tipo_materia_prima"
                                        item-value="id"
                                        :label="`Seleccione Especie*`"
                                        color="blue darken-3"
                                        persistent-hint
                                        return-object
                                        single-line
                                        dense
                    ></v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
          <small>*Campos Requeridos</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" dark @click="limpiar">Cancelar</v-btn>
          <v-btn color="green darken-1" dark @click="crear_lote" :disabled="!formulario_valido">Guardar</v-btn>
        </v-card-actions>
      </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
import {mapState} from 'vuex';
export default {
    data:()=>({
        mostrar:false,
        mostrar_loader:false,
        mensaje_loader:'',
        mensaje_alert:'',
        lote:'',
        datetime:'',
        restriccion:'',
        restricciones:[],
        especie:'',
        especies:[]
    }),
    beforeDestroy() {
        Event.$off('abrir_modal_lote');
    },
    mounted(){
        Event.$on('abrir_modal_lote',()=>{
            console.log('yes');
            // console.log('fecha_hora_actual',this.moment().format('YYYY-MM-DD HH:MM'));
            // let fecha_hora = new Date();
            this.datetime = new Date();
            this.cargarEspecies();
            this.mostrar = true;
        })
    },
    methods: {
        async consultar_lote(){
            let lote = null;
            await this.axios.get(`${this.base_url}lote/nombre_lote/${this.lote}`,this.headers).then((res)=>{
                console.log('lote',res.data.lote);
                lote = res.data.lote;
            }).catch((error)=>{
                console.log('error',error);
            });

            return lote;
        },
        async crear_lote(){
            let lote = await this.consultar_lote();
            if(lote){
                //el lote ya existe
                console.log('ya existe');
                if(lote.cerrado == 1){
                    this.mensaje_alert = `El lote ${lote.nombre_lote} ya existe, pero se encuentra cerrado`;
                }else{
                    this.mensaje_alert = `El lote ${lote.nombre_lote} ya existe`;
                }
            }else{
                // no existe el lote
                this.mensaje_loader = 'Creando Lote...';
                this.mostrar_loader = true;
                // let restriccion_id = this.restriccion.id;
                let tipo_mps_id = this.especie.id;
                //por defecto se ingresa el tipo de lote sin restricción
                let tipo_lote_id = 1;
                //en caso de que se haya elejido alguna restricción el tipo de lote será 2 (con restricción)
                // if(restriccion_id != 1 && this.restriccion != ''){
                //     tipo_lote_id = 2;
                // }
                if(this.lote.startsWith('R')){
                    tipo_lote_id = 2;
                }
                let body = {
                    nombre_lote: this.lote,
                    fecha_produccion:this.moment(this.datetime).format('YYYY-MM-DD HH:mm'),
                    tipo_lotes_id:tipo_lote_id,
                    // restricciones_id:restriccion_id
                    tipo_mps_id: tipo_mps_id
                };

                let url = `${this.base_url}lotes`;
                await this.axios.post(url,body,this.headers).then((response)=>{
                    console.log('lote_creado',response);
                    Event.$emit('lote_creado',response.data.data);
                    this.limpiar();
                    this.mostrar_loader = false;
                    this.mostrar = false;

                }).catch((error)=>{
                    console.log('error',error);
                    this.mostrar_loader = false;
                });
                console.log('body_lote',body);
            }
            
        },
        async cargar_restricciones(){
            this.mensaje_loader = 'Cargando Restricciones...';
            let url = `${this.base_url}restricciones`;
            this.mostrar_loader = true;
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('restricciones',response);
                this.restricciones = response.data.data;
                this.mostrar_loader = false;
            }).catch((error)=>{
                console.log('error',error);
                this.mostrar_loader = false;
            });
        },

        async cargarEspecies(){
            this.mensaje_loader = 'Cargando Especies...';
             this.mostrar_loader = true;
            await this.axios.get(`${this.base_url}tipo_mps/configuracion/3`,this.headers).then((response)=>{
            this.especies = response.data;
            console.log('especies',response.data);
             this.mostrar_loader = false;
          }).catch((error)=>{
            console.log('error',error);
             this.mostrar_loader = false;           
          })
        },

        limpiar(){
            this.lote = '';
            this.datetime='';
            this.restriccion='';
            this.mensaje_alert='';
            this.especie = '';
            this.restricciones=[];
            this.mostrar = false;
        }
    },
    computed: {
        ...mapState(['base_url','headers']),
        formulario_valido(){
            let valido = false;
            if(this.lote != '' && this.datetime != '' && this.especie != ''){
                valido = true;
            }
            return valido;
        }
    },
}
</script>